module.exports = __webpack_public_path__ + "static/media/SL.0ab96fdf.svg";